import CreateTagForm from './create-tag-form';

export default CreateTagForm;
